module.exports = __webpack_public_path__ + "img/HiwaQader-Hawin.eaccb177.jpg";